<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    class="content"
  >
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-content>
            <span class="md-nav-tabs-title" />
            <md-tabs
              ref="tabs"
              class="md-success"
              md-alignment="left"
            >
              <md-tab
                v-for="equipment in equipments"
                :id="equipment.type"
                :key="equipment.type"
                :md-label="equipment.description"
              >
                <md-table
                  v-model="equipment.listEquipments"
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                  >
                    <md-table-cell md-label="Nome">
                      {{ item.name }}
                    </md-table-cell>
                    <md-table-cell md-label="Tag">
                      {{ item.tag }}
                    </md-table-cell>
                    <md-table-cell md-label="Fabricante">
                      {{ item.fab }}
                    </md-table-cell>
                    <md-table-cell md-label="Modelo">
                      {{ item.model }}
                    </md-table-cell>
                  </md-table-row>
                  
                  <pagination
                    :page-size="10"
                    :total-items="equipment.totalEquipments"
                    :current-page="equipment.page"
                    :update-page="updatePageEquipment(equipment)"
                  />
                </md-table>
              </md-tab>
            </md-tabs>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <new-ticket-button />
  </div>
</template>

<script>
import NewTicketButton from "../components/NewTicketButton";
import Pagination from "../components/Pagination";

import { userService } from "../_services";
import { EventBus, events } from "../_helpers/event-bus";

const EQUIPMENT_INFO = [
  { type: "computer", description: "Clima" },
  { type: "monitor", description: "Segurança" },
  { type: "software", description: "Civil" },
  { type: "networkequipment", description: "Energia" },
  { type: "peripheral", description: "Automação" },
  { type: "printer", description: "Conectividade" },
];

export default {
  components: {
    Pagination,
    NewTicketButton,
  },
  data() {
    return {
      type: [ "info", "success", "warning", "warning", "danger", "" ],
      equipments: [],
      notifications: {
        topCenter: false,
      },
      loading: true,
    };
  },
  async created() {
    this.loading = true;

    this.equipments = await this.retrieveAllEquipments();

    this.loading = false;

    EventBus.$on(events.CHANGED_ENTITY, this.changedEntity);
  },
  beforeDestroy() {
    EventBus.$off(events.CHANGED_ENTITY, this.changedEntity);
  },
  methods: {
    async retrieveAllEquipments() {
      const equipments = await Promise.allSettled(
        EQUIPMENT_INFO.map(({ type, description }) => this.retrieveEquipmentsByType(type, description, 1))
      );

      return equipments
        .map(result => result.value || null)
        .filter(equipment => !!equipment);
    },
    async retrieveEquipmentsByType(type, description, page) {
      const result = await userService.searchEquipmentsByType(undefined, type, description, page);
      return result.totalEquipments ? result : null;
    },
    async changedEntity() {
      this.loading = true;

      this.equipments = await this.retrieveAllEquipments();

      this.loading = false;
    },
    updatePageEquipment(equipment) {
      return async (page) => {
        equipment.page = page;
        await this.updateEquipment(equipment);
        await this.refreshTabsHeight();
      };
    },
    async updateEquipment(equipment) {
      const newEquipment = await this.retrieveEquipmentsByType(equipment.type, equipment.description, equipment.page);

      equipment.listEquipments = newEquipment.listEquipments;
      equipment.totalEquipments = newEquipment.totalEquipments;
      equipment.page = newEquipment.page;
      equipment.active = newEquipment.active;
    },
    async refreshTabsHeight() {
      await this.$nextTick();
      this.$refs.tabs.calculateTabPos();
    },
  },
};
</script>
<style>

.md-tabs-content table thead {
  display: table-header-group;
}

</style>
